import ServiceLandingLayout from '../components/ServiceLandingLayout';

export default function ErpPage() {
  return <ServiceLandingLayout translationKey="erp_landing" proofLink="/case-studies/erp-middleware" />;
}
